import { CustomerRef, Discount } from '../../types/discounts';
import { AssetRequestObject } from '../types';

export enum ActionTypes {
    FetchDiscount = '[marketing/discounts/edit] FETCH_DISCOUNTS',
    FetchDiscountResponse = '[marketing/discounts/edit] FETCH_DISCOUNTS_RESPONSE',
    FetchDiscountCustomers = '[marketing/discounts/edit] FETCH_DISCOUNT_CUSTOMERS',
    FetchDiscountCustomersResponse = '[marketing/discounts/edit] FETCH_DISCOUNT_CUSTOMERS_RESPONSE',
    ClearFetchedData = '[marketing/discounts/edit] CLEAR_FETCHED_DATA',
    UpdateDiscount = '[marketing/discounts/edit] UPDATE_DISCOUNT',
    UpdateDiscountResponse = '[marketing/discounts/edit] UPDATE_DISCOUNT_RESPONSE',
    DeleteDiscount = '[marketing/discounts/edit] DELETE_DISCOUNT',
    DeleteDiscountResponse = '[marketing/discounts/edit] DELETE_DISCOUNT_RESPONSE',
    RemoveDiscountImageAsset = '[marketing/discounts/edit] REMOVE_DISCOUNT_IMAGE_ASSET',
    CreateAsset = '[marketing/discounts/edit] CREATE_ASSET',
    CreateAssetResponse = '[marketing/discounts/edit] CREATE_ASSET_RESPONSE',
    UploadAssetResponse = '[marketing/discounts/edit] UPLOAD_ASSET_RESPONSE',
}

export interface FetchDiscount {
    type: ActionTypes.FetchDiscount;
    payload: {
        accountId: string;
        discountId: string;
    };
}

export interface FetchDiscountResponse {
    type: ActionTypes.FetchDiscountResponse;
    payload: Discount;
}

export const fetchDiscount = (accountId: string, discountId: string): FetchDiscount => {
    return {
        type: ActionTypes.FetchDiscount,
        payload: {
            accountId,
            discountId,
        },
    };
};

export interface FetchDiscountCustomers {
    type: ActionTypes.FetchDiscountCustomers;
    payload: {
        accountId: string;
        discountId: string;
    };
}

export interface FetchDiscountCustomersResponse {
    type: ActionTypes.FetchDiscountCustomersResponse;
    payload: CustomerRef[];
}

export const fetchDiscountCustomers = (accountId: string, discountId: string): FetchDiscountCustomers => {
    return {
        type: ActionTypes.FetchDiscountCustomers,
        payload: {
            accountId,
            discountId,
        },
    };
};

export interface ClearFetchedData {
    type: ActionTypes.ClearFetchedData;
}

export const clearFetchedData = () => {
    return {
        type: ActionTypes.ClearFetchedData,
    };
};

export interface RemoveDiscountImageAsset {
    type: ActionTypes.RemoveDiscountImageAsset;
}

export const removeDiscountImageAsset = () => {
    return {
        type: ActionTypes.RemoveDiscountImageAsset,
    };
};

export interface UpdateDiscount {
    type: ActionTypes.UpdateDiscount;
    payload: {
        accountId: string;
        discount: Discount;
        discountId?: string;
    };
}

export interface UpdateDiscountResponse {
    type: ActionTypes.UpdateDiscountResponse;
    payload: Discount;
}

export const updateDiscount = (accountId: string, discount: Discount): UpdateDiscount => {
    return {
        type: ActionTypes.UpdateDiscount,
        payload: {
            accountId,
            discount,
            discountId: discount.id,
        },
    };
};

export interface DeleteDiscount {
    type: ActionTypes.DeleteDiscount;
    payload: {
        accountId: string;
        discountId: string;
    };
}

export interface DeleteDiscountResponse {
    type: ActionTypes.DeleteDiscountResponse;
    payload: Discount;
}

export const deleteDiscount = (accountId: string, discountId: string): DeleteDiscount => {
    return {
        type: ActionTypes.DeleteDiscount,
        payload: {
            accountId,
            discountId,
        },
    };
};

export interface CreateAsset {
    type: ActionTypes.CreateAsset;
    payload: {
        accountId: string;
        asset: AssetRequestObject;
    };
}

export interface CreateAssetResponse {
    type: ActionTypes.CreateAssetResponse;
    payload: {
        accountId: string;
        uploadUrl: string;
        publicUrl: string;
        file: Blob;
        discountId: string;
    };
    meta: {
        cause: CreateAsset;
    };
}

export const createAsset = (accountId: string, asset: AssetRequestObject): CreateAsset => {
    return {
        type: ActionTypes.CreateAsset,
        payload: {
            accountId,
            asset,
        },
    };
};

export interface UploadAssetResponse {
    type: ActionTypes.UploadAssetResponse;
    meta: {
        cause: CreateAssetResponse;
    };
}

export type Actions =
    | FetchDiscount
    | FetchDiscountResponse
    | ClearFetchedData
    | UpdateDiscount
    | UpdateDiscountResponse
    | DeleteDiscount
    | DeleteDiscountResponse
    | FetchDiscountCustomers
    | FetchDiscountCustomersResponse
    | RemoveDiscountImageAsset
    | CreateAsset
    | CreateAssetResponse
    | UploadAssetResponse;
